module.exports = __webpack_public_path__ + "img/Hub.34f95ab2.svg";